<div class="title">
    <img src="/assets/images/1malaga.png">
</div>

<app-translation></app-translation>